import dynamic from "next/dynamic";

export const DynamicContent050 = dynamic(() => import("./Content050"), {
  suspense: true,
});
